var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { "background-color": "#FAF9F6" },
      style:
        _vm.isDesktop() && !_vm.selected ? "padding-bottom: 320px" : "50px",
    },
    [
      _c("RovinietaNavigation"),
      _c("Steps", { attrs: { "current-page": 2 } }),
      _c("div", { staticClass: "container container-medium" }, [
        _c("div", { staticClass: "purchase-wrapper" }, [
          _c(
            "div",
            { staticClass: "text-center pt-2" },
            [
              _vm.category
                ? _c("Heading", {
                    attrs: {
                      title: _vm.$t("buy_vignette"),
                      routeName: "cart",
                      alignment: "text-center",
                    },
                  })
                : _vm._e(),
              _c("p", { staticClass: "pt-3" }, [
                _c("span", { staticClass: "main-text" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("step", 2)) +
                      ": " +
                      _vm._s(_vm.$t("select_the_period"))
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "selected-cat" }, [
          _vm.category && _vm.icons
            ? _c(
                "div",
                {
                  staticClass: "d-flex auto-rov-catA align-items-center black",
                },
                [
                  _c("div", {
                    staticClass: "icon cat-icon m-0",
                    class: _vm.icons[_vm.category.id - 1].icon,
                    attrs: { alt: "" },
                  }),
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(
                      _vm._s(_vm.$t("vehicles")) +
                        " / " +
                        _vm._s(_vm.capitalize(_vm.$t("vignetteWord"))) +
                        " " +
                        _vm._s(_vm.category.title) +
                        " "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _vm.category && !_vm.loading
          ? _c(
              "div",
              { staticClass: "row cards" },
              _vm._l(_vm.category.prices, function (item, key) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: {
                          el: "#form-1",
                          offset: -92, // 92px is the height of the fixed header
                        },
                        expression:
                          "{\n                el: '#form-1',\n                offset: -92, // 92px is the height of the fixed header\n            }",
                      },
                    ],
                    key: key,
                    staticClass: "col-md-3 col-6 item-card",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card card-pointer",
                        class: [
                          {
                            "card-primary":
                              _vm.valability_key == key && _vm.selected,
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.chooseValability(key)
                          },
                        },
                      },
                      [
                        _vm.valability_key == key && _vm.selected
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "elipse-complete position-absolute margin-minus",
                              },
                              [_c("div", { staticClass: "icon v-icon" })]
                            )
                          : _vm._e(),
                        _c("span", { staticClass: "number-of-passes" }, [
                          _vm._v(_vm._s(item.valability.name)),
                        ]),
                        _c("p", { staticClass: "card-text" }, [
                          _c("strong", [_vm._v(_vm._s(item.value_ron))]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$tc("currency", item.value_ron)) +
                              " (" +
                              _vm._s(item.value_eur) +
                              " EUR)"
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm.form_visible
        ? _c(
            "div",
            { staticClass: "container container-xs no-padding-mobile" },
            [
              _c(
                "div",
                { attrs: { id: "form-1" } },
                [
                  !_vm.loading
                    ? [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "fromDate" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("label_available_from")) + ":"
                              ),
                            ]),
                            _vm.errorMsgs.fromDate
                              ? _c(
                                  "span",
                                  { staticClass: "invalid-feedback" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.errorMsgs.fromDate) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("datepicker", {
                              staticClass: "form-group",
                              class: { "has-error": _vm.errorMsgs.fromDate },
                              attrs: {
                                language: _vm.getDatepickerTranslationsObj(),
                                "disabled-dates": _vm.disabledDates,
                                "bootstrap-styling": true,
                                id: "date-picker",
                              },
                              model: {
                                value: _vm.fromDate,
                                callback: function ($$v) {
                                  _vm.fromDate = $$v
                                },
                                expression: "fromDate",
                              },
                            }),
                          ],
                          1
                        ),
                        !_vm.vehicle
                          ? [
                              _c(
                                "div",
                                { staticClass: "form-group p-relative" },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("label_license_plate"))
                                    ),
                                  ]),
                                  _vm.errorMsgs.plateNo
                                    ? _c(
                                        "span",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.errorMsgs.plateNo) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("input", {
                                    staticClass: "form-control",
                                    class: {
                                      "has-error": _vm.errorMsgs.plateNo,
                                    },
                                    attrs: {
                                      type: "text",
                                      dusk: "license-plate",
                                    },
                                    domProps: { value: _vm.plateNo },
                                    on: {
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            $event.keyCode !== 38
                                          )
                                            return null
                                          $event.preventDefault()
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            $event.keyCode !== 40
                                          )
                                            return null
                                          $event.preventDefault()
                                        },
                                      ],
                                      input: (e) =>
                                        (_vm.plateNo = e.target.value),
                                    },
                                  }),
                                  _vm.isLoggedIn &&
                                  _vm.plateNo &&
                                  _vm.showAutocomplete
                                    ? _c("autocomplete", {
                                        attrs: { search: _vm.plateNo },
                                        on: {
                                          destroy: _vm.destroyAutocomplete,
                                          choose: _vm.setSearchedVehicle,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.isMandatoryChasis
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("label_chasis_number"))
                                      ),
                                    ]),
                                    _vm.errorMsgs.chasisNo
                                      ? _c(
                                          "span",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.errorMsgs.chasisNo) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.chasisNo,
                                          expression: "chasisNo",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "has-error": _vm.errorMsgs.chasisNo,
                                      },
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.chasisNo },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.chasisNo = $event.target.value
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "warning-feedback" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.chasisNumberWarning()) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.countries
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "label",
                                      { attrs: { for: "taraInmatriculare" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("label_registration_country")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.country,
                                            expression: "country",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { id: "taraInmatriculare" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.country = $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      _vm._l(_vm.countries, function (c) {
                                        return _c(
                                          "option",
                                          {
                                            key: c.id,
                                            domProps: { value: c.id },
                                          },
                                          [_vm._v(_vm._s(c.country))]
                                        )
                                      }),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  { attrs: { for: "motivCategorie" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("label_motif")) +
                                        " (optional)"
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reason,
                                      expression: "reason",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", id: "motivCategorie" },
                                  domProps: { value: _vm.reason },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.reason = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]
                          : _vm._e(),
                        _vm.vehicle
                          ? [
                              _vm.noChasisOnLoad
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("label_chasis_number"))
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.errorMsgs.chasisNo) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.chasisNo,
                                          expression: "chasisNo",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "has-error": _vm.errorMsgs.chasisNo,
                                      },
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.chasisNo },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.chasisNo = $event.target.value
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "warning-feedback" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.chasisNumberWarning()) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c("AddProductForVehicle", {
                                    attrs: {
                                      vehicle: _vm.vehicle,
                                      type: "vignette",
                                      "hide-btn": true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "sms-notification" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sms_confirm_notification,
                                  expression: "sms_confirm_notification",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.sms_confirm_notification
                                )
                                  ? _vm._i(_vm.sms_confirm_notification, null) >
                                    -1
                                  : _vm.sms_confirm_notification,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.sms_confirm_notification,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.sms_confirm_notification =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.sms_confirm_notification = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.sms_confirm_notification = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$tc(
                                    "sms_confirm_notification",
                                    Math.ceil(_vm.getSmsSetting.value),
                                    { price: _vm.getSmsSettingMessage() }
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "sms-notification" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sms_expiry_notification,
                                  expression: "sms_expiry_notification",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.sms_expiry_notification
                                )
                                  ? _vm._i(_vm.sms_expiry_notification, null) >
                                    -1
                                  : _vm.sms_expiry_notification,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.sms_expiry_notification,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.sms_expiry_notification =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.sms_expiry_notification = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.sms_expiry_notification = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$tc(
                                    "sms_expiry_notification",
                                    Math.ceil(_vm.getSmsSetting.value),
                                    { price: _vm.getSmsSettingMessage() }
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _vm.category.prices[_vm.valability_key].valability
                          .days > 7
                          ? _c("div", { staticClass: "form-group" }, [
                              _c("label", { staticClass: "sms-notification" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cnair_expiry_notification,
                                      expression: "cnair_expiry_notification",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.cnair_expiry_notification
                                    )
                                      ? _vm._i(
                                          _vm.cnair_expiry_notification,
                                          null
                                        ) > -1
                                      : _vm.cnair_expiry_notification,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.cnair_expiry_notification,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.cnair_expiry_notification =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.cnair_expiry_notification = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.cnair_expiry_notification = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("cnair_expiry_notification")
                                    ) +
                                    " "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.selected
        ? _c("div", { staticClass: "container container-xs" }, [
            !_vm.loading
              ? _c(
                  "div",
                  {
                    staticClass:
                      "action-button action-button-big-desktop d-flex justify-content-end",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-purple",
                        attrs: { type: "submit", dusk: "add-to-card-desktop" },
                        on: {
                          click: function ($event) {
                            return _vm.addToCart()
                          },
                        },
                      },
                      [
                        !_vm.getEditProduct
                          ? [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")]
                          : [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")],
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }